<div class="border-b border-b-navy-200 py-6">
  <header class="flex gap-4 justify-between items-center relative">
    <h5
      class="faq-accordion-item-title be-body-s font-medium text-navy-900 m-0"
    >
      {{ title() }}
    </h5>
    <button
      appToggleHeight
      [containerRef]="accordionItemBody"
      type="button"
      aria-label="toggle"
      [attr.aria-controls]="id()"
      class="accordion-btn click-wrapper"
    >
      <app-icon-plus-minus-toggle></app-icon-plus-minus-toggle>
    </button>
  </header>

  <div #accordionItemBody [id]="id()" role="region" class="accordion-item-body">
    <ng-content></ng-content>
  </div>
</div>
